// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__1oR8h","container":"Button_container__3B4zR","stretch":"Button_stretch__1Cz3R"};